import { useState } from 'react';
import API from '../api/api';
import {
  Box,
  TextField,
  Button,
  Stack,
  Typography,
} from '@mui/material';
import EuroIcon from '@mui/icons-material/Euro';
import { useSnackbar } from '../contexts/SnackbarContext';

export default function CheckoutForm({ tire, price, onSuccess, sellerId }) {
  const { showSnackbar, confirmSnackbar } = useSnackbar();
  const [quantity, setQuantity] = useState(1);
  const [loading, setLoading] = useState(false);

  const handleCheckout = async () => {
    try {
      const total = price != null ? Number(price) * Number(quantity || 0) : null;
      const totalText = total != null ? `${total.toFixed(2)} EUR` : 'Total -';
      const confirmed = await confirmSnackbar(`Vente normale: ${totalText}`, {
        actionLabel: 'Confirmer',
        cancelLabel: 'Annuler',
      });
      if (!confirmed) return;
      setLoading(true);
      await API.post('/stock/checkout', {
        reference: tire.reference,
        quantity,
        seller_id: sellerId || undefined,
      });
      setQuantity(1);
      showSnackbar('Vente reussie !', 'success');
      onSuccess();
    } catch (err) {
      showSnackbar(err.response?.data?.message || 'Erreur lors de la vente', 'error');
    } finally {
      setLoading(false);
    }
  };

  return (
    <Box
      sx={{
        width: { xs: '100%', sm: 130 },
        maxWidth: '100%',
        mx: 'auto',
        p: { xs: 0.9, sm: 1.2 },
        borderRadius: 3,
        background: 'var(--surface-3)',
        border: '1px solid var(--border-subtle)',
        backdropFilter: 'blur(8px)',
      }}
    >
      <Stack spacing={1}>
        <Typography
          sx={{
            fontSize: { xs: 10, sm: 11 },
            color: 'var(--text-muted)',
            fontWeight: 600,
            textTransform: 'uppercase',
            letterSpacing: 0.5,
          }}
        >
          Vente
        </Typography>
        <Typography
          sx={{ fontSize: { xs: 11, sm: 12 }, color: 'var(--text-primary)', fontWeight: 700 }}
        >
          {price != null ? `${price} EUR` : 'Prix -'}
        </Typography>

        <TextField
          type="number"
          size="small"
          inputProps={{ min: 1 }}
          value={quantity}
          onChange={(e) => setQuantity(parseInt(e.target.value, 10))}
          placeholder="Quantite"
          variant="outlined"
          fullWidth
          sx={{
            bgcolor: '#f9fafb',
            borderRadius: 2,
            '& .MuiOutlinedInput-root': {
              borderRadius: 8,
              fontSize: { xs: 12, sm: 14 },
            },
          }}
        />

        <Button
          onClick={handleCheckout}
          disabled={loading}
          fullWidth
          startIcon={<EuroIcon />}
          sx={{
            borderRadius: 999,
            fontWeight: 700,
            py: { xs: 0.6, sm: 0.8 },
            fontSize: { xs: 11, sm: 13 },
            color: '#fff',
            background: 'linear-gradient(90deg, #22c55e, #0ea5e9)',
            textTransform: 'none',
            boxShadow: '0 6px 16px rgba(14,165,233,0.35)',
            '&:hover': {
              transform: 'translateY(-1px)',
              boxShadow: '0 10px 24px rgba(14,165,233,0.5)',
            },
          }}
        >
          Vendre
        </Button>
      </Stack>

    </Box>
  );
}


